import { useEffect, useState } from "preact/hooks";
import { currentAccount } from "./account";

/** Load data for a page; reloads when the account or a dep changes. */
export function useLoad<R>(fn: () => Promise<R>, deps: unknown[] = []) {
  const [state, set] = useState<{ data?: R; error?: string; loading: boolean }>({ loading: true });
  const [tick, setTick] = useState(0);
  const acc = currentAccount.value;
  useEffect(() => {
    let live = true;
    set((s) => ({ ...s, loading: true }));
    fn().then(
      (data) => live && set({ data, loading: false }),
      (e: Error) => live && set({ error: e.message, loading: false }),
    );
    return () => {
      live = false;
    };
  }, [acc, tick, ...deps]);
  return { ...state, reload: () => setTick((n) => n + 1) };
}
